import styled from 'styled-components'
import { violet, white } from 'theme/colors'
import { DEVICES } from 'theme/devicesSizes'

export const Container = styled.div`
  height: 80vh;
  @media ${DEVICES.laptop} {
    height: 100%;
    overflow-y: scroll;
  }
  @media ${DEVICES.mobile} {
    height: 100%;
    overflow-x: hidden;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
  } 
`
export const ViewSubContainer = styled.div`
  margin-left: 3.7vw;
  width: 87%;
  padding-top: 1vw;
  display: flex;
  flex-direction: column;
  gap: 30px;
  @media ${DEVICES.mobile} {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
  }
`

export const ViewColumnsContainer = styled.div`
  display: flex;
  height: 700px;
  flex-direction: row;
  justify-content: space-between;
  @media ${DEVICES.tablet} {
    height: 100%;
    align-items: center;
    flex-direction: column;
  }
  @media ${DEVICES.mobile} {
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
  }
`

export const ViewLeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  gap: 16px;
  @media ${DEVICES.tablet} {
    width: 100%;
    height: 100%;
  }
  @media ${DEVICES.mobile} {
    width: 100%;
    height: 100%;
  }
`

export const ViewRightColumn = styled.div`
  width: 55%;
  @media ${DEVICES.tablet} {
    position: static;
    width: 100%;
    height: 850px;
    margin-top: 24px;
  }
  @media ${DEVICES.mobile} {
    width: 100%;
    height: 650px;
    margin-top: 24px;
  }
`

export const InvestmentLegend = styled.text`
  font-size: 10px;
  font-weight: 600;
  color: ${violet};
  @media ${DEVICES.mobile} {
    font-size: 13px;
  }
`

export const InvestmentActivated = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  background-color: ${white};
  border-radius: 5px;
  padding: 12px;
  gap: 10px;
  width: 100%;
  @media ${DEVICES.mobile} {
    width: 96%;
  }
`

export const ViewBannerContainer = styled.div`
`

export const ImageAdvertising = styled.img`
  border-radius: 5px;
  width: 100%;
`

export const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 20px 10px 0px;
  margin: 0 auto;
  overflow: hidden;
`

export const CarouselSlides = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  gap: 10px;
  padding-bottom: 8px;
  /* Hides the scroll bar in most browsers */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE & Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari & Opera */
  }
  @media ${'screen and (max-width: 600px)'} {
     max-width: 100%;
  }
  @media ${'screen and (max-width: 430px)'} {
     max-width: 395px;
  }
`

export const CarouselSlide = styled.div`
  min-width: 100%;
  max-width: 100%;
  transition: box-shadow 0.3s;
`
